import React from 'react'
import _ from 'lodash/fp'
import { connect } from 'react-redux'

import { actions as authActions } from '../../reducers/auth'

import { Link } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'

import Typography from '@material-ui/core/Typography'
import Paper from '@material-ui/core/Paper'

const useStyles = makeStyles(theme => ({
  paper: {
    padding: 24,
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    [theme.breakpoints.up('md')]: {
      maxWidth: '50%',
      height: 'unset'
    }
  }
}))

export default _.compose(
  connect(null, { doLogin: authActions.loginRequest })
)(props => {
  const classes = useStyles()
  const [err, setError] = React.useState()
  const resp = _.get('match.params.resp', props)
  React.useEffect(() => {
    try {
      const raw = window.atob(resp)
      const { id, otp, provider, error } = JSON.parse(raw)
      if (error) {
        setError(error)
      }
      if (id && otp && provider) {
        props.doLogin({ email: id, password: otp, provider })
      }
    } catch (e) {
      setError('Error parsing server response')
      console.warn(e)
    }
  }, [resp, props.doLogin])
  if (!err) {
    return false
  }

  return (
    <div style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <Paper className={classes.paper}>
        <Typography variant='h4' component='h1'>We were unable to sign you in: {err}</Typography>
        <Typography variant='h5' component='p'><Link to='/login'>Go back to sign in</Link></Typography>
      </Paper>
    </div>
  )
})
